<template>
	<v-menu>
		<template #activator="{ on }">
			<slot name="activator" :on="on"></slot>
		</template>

		<v-list dense>
			<v-list-item
					v-for="color in colors"
					:key="color"
					:color="color"
			>
				<v-chip
						:color="color"
						@click="selectColor(color)"
						v-html="colorChipText"
				/>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
	export default {
		name: 'EditColorMenu',
		props: {
			tagId: {
				type: Number,
				required: true,
			},
			colors: {
				type: Array,
				required: true,
			},
		},
		computed: {
			colorChipText() {
				const symbol = '&nbsp;';
				const amount = 15;

				return (new Array(amount)).join(symbol);
			},
		},
		methods: {
			selectColor(color) {
				this.$http.put(`/api/v1/tags/${this.tagId}`, {
					color,
				})
					.then(response => {
						this.$emit('changed', response.data.data);
					})
			},
		},
	};
</script>

<style scoped>

</style>
